import React from "react";
import InputPrimaryComponents from "./inputPrimaryComponents";
import { Button } from "primereact/button";

export default function InputIterator({
  control,
  errors,
  onClick,
  formRender,
}) {
  return (
    <React.Fragment>
      {formRender?.map((item, index) => {
        if (item?.item) {
          return (
            <div className={`grid ${item?.item?.[0]?.class}`} key={index}>
              {item?.item?.map((item, index) => {
                return (
                  <div className="col-6">
                    <InputPrimaryComponents
                      key={index}
                      type={item.type}
                      control={control}
                      errors={errors}
                      name={item.name}
                      label={item.label}
                      rules={item.rules}
                      value={item?.value}
                      options={item.options}
                      maxDate={item?.maxDate}
                      minDate={item?.minDate}
                      infoText={item.infoText}
                      required={item.required}
                      disabled={item?.disabled}
                      className={item?.className}
                      autoFocus={item?.autoFocus}
                      placeholder={item?.placeholder}
                      maxLength={item?.maxLength}
                      autoComplete={item?.autoComplete}
                      inputParentClass={item?.inputParentClass}
                      inter={item?.inter}
                      onClick={onClick}
                    />
                  </div>
                );
              })}
            </div>
          );
        }
        
        // Handle button group type
        if (item?.type === "buttonGroup") {
          return (
            <div key={index} className="pb-4">
              <div className="flex justify-content-between gap-3">
                {item?.buttons?.map((button, btnIndex) => (
                  <Button
                    key={btnIndex}
                    icon={button.icon}
                    label={button.label}
                    className="primarySuccessButton font-medium text-sm rounded-xl"
                    onClick={() => onClick?.(button.onClick, button)}
                  />
                ))}
              </div>
            </div>
          );
        }
        
        return (
          <InputPrimaryComponents
            key={index}
            type={item.type}
            control={control}
            errors={errors}
            name={item.name}
            label={item.label}
            rules={item.rules}
            value={item?.value}
            options={item.options}
            minDate={item?.minDate}
            maxDate={item?.maxDate}
            infoText={item.infoText}
            inter={item?.inter}
            required={item.required}
            disabled={item?.disabled}
            autoFocus={item?.autoFocus}
            className={item?.className}
            nestedInput={item?.nestedInput}
            placeholder={item?.placeholder}
            maxLength={item?.maxLength}
            autoComplete={item?.autoComplete}
            nestedOnClick={item?.nestedOnClick}
            inputParentClass={item?.inputParentClass}
            onClick={onClick}
          />
        );
      })}
    </React.Fragment>
  );
}
